var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosedOrderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M642.4,351.7V242.3C642.5,108.7,533.7,0,400.1,0C266.4,0,157.7,108.7,157.7,242.3v109.4h-52.1V800h588.7 V351.7H642.4z M249,242.3c0-83.2,67.8-150.9,151.1-150.9c83.2,0,150.9,67.7,150.9,150.9v109.4H249V242.3z M441.7,677.1h-83.2 L371,554.2c-15.4-9.6-25.7-26.7-25.7-46.3c0-30.2,24.5-54.7,54.9-54.7c30.2,0,54.6,24.5,54.6,54.7c0,19.6-10.2,36.7-25.7,46.3 L441.7,677.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedOrderIcon);
export default __webpack_public_path__ + "static/media/closed_order_icon.18ddfbe1250d49aab5ce90e579e2d8e5.svg";
export { ForwardRef as ReactComponent };